import { render, staticRenderFns } from "./NewCustomField.vue?vue&type=template&id=a97defd0&scoped=true&"
import script from "./NewCustomField.vue?vue&type=script&lang=js&"
export * from "./NewCustomField.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomField.vue?vue&type=style&index=0&id=a97defd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97defd0",
  null
  
)

export default component.exports